import { Component } from '@angular/core';

@Component({
  selector: 'fnsr-home',
  standalone: true,
  templateUrl: './home.component.html'
})
export class HomeComponent {

}
